module.exports = __webpack_public_path__ + "img/sy-logo.2aee9001.png";